import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { jugadoresAPI } from '../../services/api';

const API_URL = process.env.REACT_APP_API_URL || 'https://lossaliasfutbolclub.com/api';
const UPLOADS_BASE = API_URL.replace('/api', '') + '/uploads/documentos/';

const JugadoresList = () => {
  const [jugadores, setJugadores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const [filtroActivo, setFiltroActivo] = useState('true');
  const [filtroCategoria, setFiltroCategoria] = useState('');

  useEffect(() => {
    loadJugadores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroStatus, filtroActivo, filtroCategoria]);

  const loadJugadores = async () => {
    try {
      setLoading(true);
      setError('');
      const params = {};
      if (filtroStatus) params.status = filtroStatus;
      if (filtroActivo) params.activo = filtroActivo;
      if (filtroCategoria) params.categoria = filtroCategoria;
      if (search.trim()) params.search = search.trim();
      const response = await jugadoresAPI.getAll(params);
      setJugadores(response.data);
    } catch (err) {
      setError('Error cargando jugadores');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    loadJugadores();
  };

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return '--';
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const m = hoy.getMonth() - nacimiento.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < nacimiento.getDate())) edad--;
    return edad;
  };

  const getStatusBadge = (status) => {
    const estilos = {
      regular: 'bg-green-100 text-green-800',
      media_beca: 'bg-yellow-100 text-yellow-800',
      becado: 'bg-blue-100 text-blue-800',
    };
    const labels = {
      regular: 'Regular',
      media_beca: 'Media Beca',
      becado: 'Becado',
    };
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${estilos[status] || 'bg-gray-100 text-gray-800'}`}>
        {labels[status] || status}
      </span>
    );
  };

  const getCategoriaBadge = (categoria) => {
    const estilos = {
      'Sub-10': 'bg-purple-100 text-purple-800',
      'Sub-12': 'bg-indigo-100 text-indigo-800',
      'Sub-14': 'bg-teal-100 text-teal-800',
      'Sub-16': 'bg-orange-100 text-orange-800',
      'Sub-18': 'bg-red-100 text-red-800',
      'Pre-infantil': 'bg-pink-100 text-pink-800',
      'Mayor': 'bg-gray-100 text-gray-800',
    };
    if (!categoria) return null;
    return (
      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${estilos[categoria] || 'bg-gray-100 text-gray-800'}`}>
        {categoria}
      </span>
    );
  };

  const getRepresentante = (j) => {
    if (j.padre_nombre) return `${j.padre_nombre} ${j.padre_apellido || ''}`.trim();
    if (j.madre_nombre) return `${j.madre_nombre} ${j.madre_apellido || ''}`.trim();
    return '--';
  };

  const getFotoUrl = (j) => {
    if (j.foto_url) {
      if (j.foto_url.startsWith('http')) return j.foto_url;
      return UPLOADS_BASE + j.foto_url;
    }
    return null;
  };

  const statusTabs = [
    { key: '', label: 'Todos', icon: '👥' },
    { key: 'regular', label: 'Regulares', icon: '🟢' },
    { key: 'media_beca', label: 'Media Beca', icon: '🟡' },
    { key: 'becado', label: 'Becados', icon: '🔵' },
  ];

  return (
    <div>
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Jugadores</h1>
          <p className="text-gray-500 text-sm mt-1">{jugadores.length} jugador{jugadores.length !== 1 ? 'es' : ''} registrado{jugadores.length !== 1 ? 's' : ''}</p>
        </div>
        <Link to="/admin" className="text-lsfc-blue-600 hover:text-lsfc-blue-800 font-medium text-sm">
          ← Volver al Dashboard
        </Link>
      </div>

      {/* Barra de busqueda */}
      <form onSubmit={handleSearch} className="mb-4">
        <div className="flex gap-2">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar por nombre, apellido o cedula..."
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lsfc-blue-500 focus:border-transparent"
          />
          <button type="submit" className="px-4 py-2 bg-lsfc-blue-600 text-white rounded-lg hover:bg-lsfc-blue-700 font-medium">
            Buscar
          </button>
        </div>
      </form>

      {/* Filtros */}
      <div className="flex flex-wrap gap-2 mb-4">
        {statusTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setFiltroStatus(tab.key)}
            className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
              filtroStatus === tab.key
                ? 'bg-lsfc-blue-600 text-white shadow-lg'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
            }`}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
        <div className="ml-auto flex gap-2">
          <select
            value={filtroCategoria}
            onChange={(e) => setFiltroCategoria(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
          >
            <option value="">Todas las categorias</option>
            <option value="pre-infantil">Pre-infantil</option>
            <option value="sub-10">Sub-10</option>
            <option value="sub-12">Sub-12</option>
            <option value="sub-14">Sub-14</option>
            <option value="sub-16">Sub-16</option>
            <option value="sub-18">Sub-18</option>
            <option value="mayor">Mayor</option>
          </select>
          <select
            value={filtroActivo}
            onChange={(e) => setFiltroActivo(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
          >
            <option value="true">Activos</option>
            <option value="false">Inactivos</option>
            <option value="">Todos</option>
          </select>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div className="bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-lg mb-4">
          {error}
        </div>
      )}

      {/* Loading */}
      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lsfc-blue-600"></div>
        </div>
      ) : jugadores.length === 0 ? (
        <div className="bg-white rounded-xl shadow-lg p-12 text-center">
          <div className="text-5xl mb-4">⚽</div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2">No hay jugadores</h3>
          <p className="text-gray-500">No se encontraron jugadores con los filtros seleccionados</p>
        </div>
      ) : (
        /* Grid de tarjetas */
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {jugadores.map((j) => (
            <Link
              key={j.id}
              to={`/admin/jugadores/${j.id}`}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all overflow-hidden group"
            >
              <div className="p-4">
                <div className="flex items-start gap-4">
                  {/* Foto */}
                  <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                    {getFotoUrl(j) ? (
                      <img src={getFotoUrl(j)} alt={j.nombres} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-lsfc-blue-100">
                        <span className="text-2xl">⚽</span>
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0">
                    <h3 className="font-bold text-gray-900 truncate group-hover:text-lsfc-blue-600 transition-colors">
                      {j.apellidos} {j.nombres}
                    </h3>
                    <p className="text-sm text-gray-500">{j.cedula}</p>
                    <div className="flex items-center gap-2 mt-1 flex-wrap">
                      <span className="text-xs text-gray-500">{calcularEdad(j.fecha_nacimiento)} anos</span>
                      <span className="text-xs text-gray-300">|</span>
                      <span className="text-xs text-gray-500">{j.sexo === 'M' ? 'Masculino' : 'Femenino'}</span>
                      {j.categoria && getCategoriaBadge(j.categoria)}
                    </div>
                  </div>

                  {/* Status */}
                  <div className="flex-shrink-0">
                    {getStatusBadge(j.status)}
                  </div>
                </div>

                {/* Info adicional */}
                <div className="mt-3 pt-3 border-t border-gray-100 grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <span className="text-gray-400">Representante:</span>
                    <p className="text-gray-700 truncate">{getRepresentante(j)}</p>
                  </div>
                  <div>
                    <span className="text-gray-400">Telefono:</span>
                    <p className="text-gray-700">{j.telefono_celular || j.padre_telefono || '--'}</p>
                  </div>
                </div>

                {!j.activo && (
                  <div className="mt-2 px-2 py-1 bg-red-50 text-red-600 text-xs rounded font-medium text-center">
                    INACTIVO
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default JugadoresList;
